/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from "../Alert";
import LoadingAlert from "../LoadingAlert";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import ACH from "./Methods/ACH";
import ATHMovil from "./Methods/ATHMovil";
import CreditCard from "./Methods/CreditCard";
import GiftCard from "./Methods/GiftCard";
import GooglePay from "./Methods/GooglePay";
import "./Payment.css";
import PaymentCom from "./PaymentCom";

class Payment extends PaymentCom {

    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
        await this.loadSession(this.props.params.sid);
    }


    success = (info) => {
        this.props.navigate(`/gateway/${this.props.params.sid}/success`);
    }

    error = (msg) => {
        console.error(msg);
        this.alert(msg);
    }

    cancel = () => {
        this.props.navigate(`/gateway/${this.props.params.sid}`);
    }

    render() {
        if (!this.state.session) {
            if (this.state.error)
                return <Alert type="danger">{this.state.error}</Alert>;
            return <LoadingAlert />;
        }
        const method = this.props.params.method;
        return <div className="container py-3">
            {method === 'cc' && <CreditCard
                onSuccess={this.success}
                onError={this.error}
                onCancel={this.cancel}
                session={this.state.session}
                merchant={this.state.merchant}
            />}
            {method === 'gc' && <GiftCard
                onSuccess={this.success}
                onError={this.error}
                onCancel={this.cancel}
                session={this.state.session}
                merchant={this.state.merchant}
            />}
            {method === 'am' && <ATHMovil
                onSuccess={this.success}
                onError={this.error}
                onCancel={this.cancel}
                session={this.state.session}
                merchant={this.state.merchant}
            />}
            {method === 'gp' && <GooglePay
                onSuccess={this.success}
                onError={this.error}
                onCancel={this.cancel}
                session={this.state.session}
                merchant={this.state.merchant}
            />}
            {method === 'bk' && <ACH
                onSuccess={this.success}
                onError={this.error}
                onCancel={this.cancel}
                session={this.state.session}
                merchant={this.state.merchant}
            />}
        </div>
    }
}

export default withParamsAndNavigate(Payment);